<template>
	<component :is="pageComponent" />
</template>

<script>
const Results = () =>
	import(/* webpackChunkName: "results" */ "@/pages/results");
const OldResults = () =>
	import(/* webpackChunkName: "old-results" */ "@/pages/results-en-new");

export default {
	name: "ResultsPageSwitcher",
	computed: {
		pageComponent() {
			if (isFeatureEnabled("NewResultsPage")) {
				return Results;
			}

			return OldResults;
		},
	},
};
</script>
